import Link from 'next/link';
import React, { useEffect, useState } from 'react';

import { VerifyAccount } from '@/assets';
import { Buttons } from '@/components';
import AvatarPlaceholder from '@/components/avatar-default';
import { useRouter } from '@/provider/RouterProvider';
import { useAuth } from '@/provider/UserProvider';
import { postFollowById } from '@/services/follow';
import type { UserProfile } from '@/types/user';
import { reportedErrorAuthenticated } from '@/utils';

const ItemCreator: React.FC<{
  creator: UserProfile;
}> = ({ creator }) => {
  const router = useRouter();
  const [isFollowing, setIsFollowing] = useState(creator.isFollow);
  const url = `/profile/${creator.publicAddress}`;
  const { isLogin } = useAuth();

  useEffect(() => {
    setIsFollowing(creator.isFollow);
  }, [creator.isFollow]);

  const onFollowSubmit = async () => {
    if (!isLogin) {
      reportedErrorAuthenticated();
      return;
    }
    setIsFollowing(!isFollowing);
    await postFollowById(creator.id);
  };

  return (
    <div className="flex items-center justify-between">
      <Link href={url} onClick={() => router.push(url)} className="flex items-center">
        <div className="h-[44px] w-[44px] overflow-hidden rounded-[50%]">
          <AvatarPlaceholder address={creator.publicAddress} src={creator.picture} />
        </div>
        <div className="ml-3">
          <div className="-mb-1 flex items-center">
            <p className="line-clamp-1 max-w-[120px] text-[16px] text-black">{creator.username}</p>
            {creator.isPartner || (creator.verify && <VerifyAccount className="scale-[0.6]" />)}
          </div>
          {/* <span className="text-[14px] text-gray-500 line-clamp-1">@{creator.username}</span> */}
        </div>
      </Link>
      <Buttons
        onClick={onFollowSubmit}
        typeBtn={isFollowing && isLogin ? 'cancel' : 'secondary'}
        className="ml-8 h-[32px] min-w-[100px] text-[13px]"
      >
        {isFollowing && isLogin ? 'Following' : 'Follow'}
      </Buttons>
    </div>
  );
};

export default ItemCreator;
